import axios from 'axios';
import {handleRequestError} from '../errorHandler';
import authHeader from "./auth.header";
import axiosCache from '../components/cache/axiosCache'
import {APIResponse, Product} from "../types/APITypes";

const SDM_SERVICE_URL = '/api/sdm';
const ctype = {'Content-Type': 'application/json'}

class ProductService {
    async getProducts(noCache: boolean) {

        const config: any = {headers: { ...authHeader(), ...ctype }};

        if (!noCache) {
            config.id = 'product';
        }

        const axiosInstance = noCache ? axios : axiosCache;

        try {
            const response = await axiosInstance.get(`${SDM_SERVICE_URL}/product`, config);
            let resp = response.data as unknown as APIResponse;
            return resp.result as unknown as Product[];
        } catch (error) {
            handleRequestError(error);
        }
    }

    async createProduct(
        contractSpecifications: {
            contractCode: string | undefined;
            assetClass: string| undefined;
            shortDescription: string| undefined;
            description: string| undefined;
            currency: string| undefined;
            underlier: string| undefined;
            multiplier: string| undefined;
            contractSize: string| undefined;
            uom: string| undefined;
            settlementType: string| undefined;
            maturityRule: string| undefined;
            url: string| undefined;
        }[],
        mic?: string
    ) {
        try {
            const url = mic
                ? `${SDM_SERVICE_URL}/product/create?mic=${encodeURIComponent(mic)}`
                : `${SDM_SERVICE_URL}/product/create`;

            const response = await axios.post(
                url,
                contractSpecifications,
                { headers: { ...authHeader(), ...ctype } }
            );
            return response.data as unknown as APIResponse;
        } catch (error) {
            console.error("Error occurred:", error);
            throw error;
        }
    }

    async updateProduct(productData: {
        contractCode: string;
        mic: string;
        description: string;
        underlier: string;
        active: boolean;
    }) {
        try {
            const response = await axios.post(`${SDM_SERVICE_URL}/updateProduct`, productData,
                {
                    headers: {...authHeader(), ...ctype}
                });
            let resp = response.data as unknown as APIResponse;
            return resp.result as unknown as Product;
        } catch (error) {
            handleRequestError(error);
        }
    }

    async deleteProduct(uuid: string) {
        try {
            const response = await axios.delete(`${SDM_SERVICE_URL}/product`, {
                headers: {...authHeader(), ...ctype},
                params: {uuid},
            });
            let resp = response.data as unknown as APIResponse;
            return resp.result as unknown as Product;
        } catch (error) {
            handleRequestError(error);
        }
    }

}

export default new ProductService();
